import React, {Component} from 'react';
import styles from './detailBonusStates.module.scss';

export default class BonusesExpired extends Component {
  render() {
    return (
      <div className={styles.BonusesExpiredState}>
        <div className={styles.BonusesExpiredStateText}>
          <span>Данный бонус уже не активен. Закончился срок действия акции или количество промокодов.</span>
        </div>
      </div>
    )
  }
}